module.exports = __webpack_public_path__ + "img/forward.739fd69e.svg";